import {
  BasicDialog,
  BasicDialogActions,
  BasicDialogBody,
} from '@/components/basicDialog';
import { Button } from '@/routes/_embaUserLayout/-components/Button';
import { LessonTitle } from '@/routes/_embaUserLayout/-components/LessonTitle';
import type { FC } from 'react';
import { EvaluationSummary } from '../-components/EvaluationSummary';
import { Goal } from '../-components/Goal';
import styles from './index.module.scss';

interface PageProps {
  onOpenModal: () => void;
  onCloseModal: () => void;
  onOverwriteGoal: () => Promise<void>;
  onNext: () => void;
  isSummarized: boolean;
  isOverwriting: boolean;
  overwriteBlockReason: string | null | undefined;
  goal: string | null | undefined;
  isEditModalOpen: boolean;
  editedGoal: string;
  setEditedGoal: (goal: string) => void;
  isTimeoutModalOpen: boolean;
  setIsTimeoutModalOpen: (open: boolean) => void;
  chapterName: string;
  lessonName: string;
}

const Page: FC<PageProps> = ({
  onOpenModal,
  onCloseModal,
  onOverwriteGoal,
  onNext,
  isSummarized,
  isOverwriting,
  overwriteBlockReason,
  goal,
  isEditModalOpen,
  editedGoal,
  setEditedGoal,
  isTimeoutModalOpen,
  setIsTimeoutModalOpen,
  chapterName,
  lessonName,
}) => {
  return (
    <>
      <LessonTitle chapterName={chapterName} lessonName={lessonName} />

      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>ロールプレイ結果</h1>

          <Goal
            goal={goal}
            isSummarized={isSummarized}
            onOpenModal={onOpenModal}
            overwriteBlockReason={overwriteBlockReason}
          />

          <EvaluationSummary isEvaluated={isSummarized} />

          <div className={styles.buttonContainer}>
            <Button onClick={onNext} disabled={!isSummarized}>
              次へ
            </Button>
          </div>
        </div>

        <BasicDialog
          open={isEditModalOpen}
          onOpenChange={onCloseModal}
          showCloseButton={true}
          title="目標の編集"
          description="目標の編集"
          closeLinkText="キャンセル"
        >
          <BasicDialogBody align="left">
            <div className={styles.editArea}>
              <textarea
                id="goal-textarea"
                value={editedGoal}
                onChange={(e) => setEditedGoal(e.target.value)}
                className={styles.textarea}
                rows={5}
                disabled={isOverwriting}
                maxLength={1000}
              />
              <div className={styles.noticeArea}>
                <span>本設問の回答は受講管理者に共有されます。</span>
                <span className={styles.charLimit}>（1000文字以内）</span>
              </div>
            </div>
          </BasicDialogBody>

          <BasicDialogActions>
            <Button
              onClick={() => onOverwriteGoal().catch(() => {})}
              disabled={isOverwriting || !editedGoal.trim()}
            >
              {isOverwriting ? '保存中' : '保存する'}
            </Button>
          </BasicDialogActions>
        </BasicDialog>
      </div>
      <BasicDialog
        open={isTimeoutModalOpen}
        onOpenChange={setIsTimeoutModalOpen}
        showCloseButton={true}
        title="時間切れで終了しました"
        description="時間切れで終了しました"
      >
        <BasicDialogActions>
          <Button
            onClick={() => {
              setIsTimeoutModalOpen(false);
            }}
          >
            閉じる
          </Button>
        </BasicDialogActions>
      </BasicDialog>
    </>
  );
};

export default Page;
